import React, { FunctionComponent, MutableRefObject } from 'react';

import { useIntl } from 'react-intl';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { ContentSection } from './components/Section';
import Logo from './components/Logo';
import UserQuote from './components/UserQuote';

type SectionFeedback = {
  sectionRef: MutableRefObject<null>;
};

const SectionFeedback: FunctionComponent<SectionFeedback> = ({
  sectionRef,
}) => {
  const { formatMessage } = useIntl();

  return (
    <ContentSection
      sectionRef={sectionRef}
      alignment="right"
      supportContent={<></>}
    >
      <Typography variant="h3">
        {formatMessage(
          { id: 'feedback.title' },
          { logo: <Logo key="section.feedback.logo" /> }
        )}
      </Typography>
      <Box pt={2}>
        <UserQuote
          author="Cosmo Knudsen"
          authorKey="cosmo"
          color="textPrimary"
        />
        <UserQuote author="Leah-Marie" authorKey="leah" color="textPrimary" />
        <UserQuote author="Clara" authorKey="clara" color="textPrimary" />
        <UserQuote author="Julia" authorKey="julia" color="textPrimary" />
      </Box>
    </ContentSection>
  );
};

export default SectionFeedback;
